import React from 'react';
export function Guarantee() {
  return <section className="bg-white text-navy py-16 px-4" data-id="element-108">
      <div className="max-w-[720px] mx-auto text-center flex flex-col items-center" data-id="element-109">
        <div className="text-5xl mb-6" data-id="element-110">🛡️</div>
        <h2 className="text-2xl md:text-3xl font-bold mb-4 leading-tight" data-id="element-111">
          Garantía 7 días — Sin preguntas
        </h2>
        <p className="text-[16px] text-navy/80 max-w-[500px] mb-8 leading-[1.6]" data-id="element-112">
          Abrís el sistema. Lo aplicás. Si en 7 días no es lo que esperabas, te
          devolvemos el 100% sin formularios, sin drama.
        </p>
        <span className="inline-block bg-emerald/10 text-emerald font-bold px-4 py-2 rounded-full text-sm border border-emerald/20" data-id="element-113">
          Tasa de devoluciones: menos del 1%.
        </span>
      </div>
    </section>;
}